import events from "@/events";
import { sendUniqEvent } from "@/services/tracking/gtm";
import { isClientSideRendering } from "@/ssr-utils/ssr-env";
import globals from "@/utils/globals";
import { getCurrentPageUrl } from "@/utils/location";
import { trackEvent } from "@/services/tracking";
import { init as initCookieConsentTracking } from "@/modules/cookie-consent-tracking";

initCookieConsentTracking();

// This is a global Cookiebot callback which is fired when user 1st time
// accepts consent and on every subsequent page load
// https://support.cookiebot.com/hc/en-us/articles/360003793854-Google-Tag-Manager-deployment

const informAboutCookieConsent = () => {
  if (window.Cookiebot.consent.preferences) {
    sendUniqEvent({ "event": "cookieconsent_preferences" });
  }

  if (window.Cookiebot.consent.statistics) {
    sendUniqEvent({ "event": "cookieconsent_statistics" });
  }

  if (window.Cookiebot.consent.marketing) {
    sendUniqEvent({ "event": "cookieconsent_marketing" });
  }

  // On IE11, occasionally events is undefined here, which interferes with
  // other scripts (like the page-loader and ab test toggler).
  // https://github.com/blinkist/blinkist-web/pull/2276
  if (typeof events !== "undefined") {
    events.emit("cookiebot:accept");
  }
};

const eventHandler = (event) => {
  if (event === "CookiebotOnAccept") {
    informAboutCookieConsent();
  } else if (event === "CookiebotOnDialogDisplay") {
    removeOldBanner();
    removeNewBanner();

    if (globals.autoCookieConsent) {
      setTimeout(() => {
        window.Cookiebot.submitCustomConsent(false, false, false);
      });
    }
  } else if (event === "CookiebotOnDialogInit") {
    setTimeout(() => {
      globals.store.commit("cookiesSubmitted", false);
    });
  } else if (event === "CookiebotOnLoad") {
    setTimeout(() => {
      globals.store.dispatch("initCookies", {
        consented: window.Cookiebot.consented,
        options: { ...window.Cookiebot.consent }
      });
    });
  }
};

const removeOldBanner = () => {
  const banner = document.getElementById("cookiebanner");
  if (banner) banner.parentNode.removeChild(banner);
};

const removeNewBanner = () => {
  const banner = document.querySelector(".vue-cookie-banner");
  if (banner) banner.parentNode.removeChild(banner);
};

export const hasStatisticsConsent = () => {
  return window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.statistics;
};

export const consent = (options) => {
  window.Cookiebot.submitCustomConsent(options.preferences, options.statistics, options.marketing);
  trackEvent("store-20200728-user", "1-consent-cookies", options);

  events.emit("cookies:modified");
};

export const consentAll = () => {
  consent({
    preferences: true,
    statistics: true,
    marketing: true
  });
};

export const initCookiebotEvents = () => {
  // handle all the events that we previously collected before this script was parsed -> see _cookiebot.html.erb
  window.cookiebotEvents && window.cookiebotEvents.forEach(eventHandler);
  // once we made it here, we stop collecting events and switch over to handling events one by one
  window.cookiebotEvents = { push: eventHandler };

  // Allow all cookies on localhost development
  if (globals.env === "development" && getCurrentPageUrl().hostname === "localhost") {
    setTimeout(() => {
      globals.store.dispatch("initCookies", {
        consented: true,
        options: {
          necessary: true,
          preferences: true,
          statistics: true,
          marketing: true
        }
      });
    });
  }
};

if (isClientSideRendering()) {
  initCookiebotEvents();
}

export default eventHandler;
